import FiletypeIcon from './FiletypeIcon';
import './FiletypeIcon.scss';

export default FiletypeIcon;
